import { EMPTY_OBJECT, EMPTY_ARRAY } from "../../../../utils/empty.js";
import { useRenderElement } from "../../useRenderElement.js";
import { useCompositeItem } from "./useCompositeItem.js";
function CompositeItem(componentProps) {
  const {
    render,
    className,
    style,
    state = EMPTY_OBJECT,
    props = EMPTY_ARRAY,
    refs = EMPTY_ARRAY,
    metadata,
    stateAttributesMapping,
    tag = "div",
    ...elementProps
  } = componentProps;
  const {
    compositeProps,
    compositeRef
  } = useCompositeItem({
    metadata
  });
  return useRenderElement(tag, componentProps, {
    state,
    // The composite ref attaches first so an outer item wins when nested items share a DOM node.
    ref: [compositeRef, ...refs],
    props: [compositeProps, ...props, elementProps],
    stateAttributesMapping
  });
}
export {
  CompositeItem
};
//# sourceMappingURL=CompositeItem.js.map
